import MojitoCore from 'mojito/core';
import TimedTooltipImpl from './timed-tooltip.js';
import PropTypes from 'prop-types';
import { noop } from 'mojito/utils';

const { UIView } = MojitoCore.Presentation;

/**
 * Tooltip that auto-closes after configured time duration.
 *
 * @class TimedTooltip
 * @memberof Mojito.Presentation.Components
 */

/**
 * `TimedTooltip` component prop types.
 *
 * @property {Function} [onClose = () => {}] - Callback for closing tooltip.
 * @property {string} [class] - Class name assigned to the root element.
 *
 * @memberof Mojito.Presentation.Components.TimedTooltip
 */
const propTypes = {
    onClose: PropTypes.func,
    class: PropTypes.string,
};

const defaultProps = {
    onClose: noop,
};

export default UIView('TimedTooltip', TimedTooltipImpl, propTypes, defaultProps);
